import { useDashboardIdentity } from './useDashboardIdentity';
import { useQuery } from '@tanstack/react-query';
import type { DashboardMapPointsResponse } from '@evi/shared';
import { fetchDashboardMapPoints } from '@/lib/api';

/**
 * Dashboard map widget data hook. Live: charger events refetch the
 * pins (online counts) through LiveUpdatesProvider; no poll.
 */
export function useDashboardMapPoints() {
  const identity = useDashboardIdentity();
  return useQuery<DashboardMapPointsResponse>({
    queryKey: ['dashboard', identity, 'map-points'],
    queryFn: fetchDashboardMapPoints,
    staleTime: 60_000,
  });
}
